import { Component, Input, Output, EventEmitter } from '@angular/core';


export interface TabItem {
  label: string;
  path: string;
  disabled?: boolean;
}

@Component({
    selector: 'ins-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    imports: [],
})
export class TabsComponent {
  @Input() tabs: TabItem[] = [];
  @Input() activeTab: string;
  @Output() tabChange = new EventEmitter<string>();

  selectTab(tab: TabItem) {
    if (!tab.disabled && tab.path !== this.activeTab) {
      this.activeTab = tab.path;
      this.tabChange.emit(tab.path);
    }
  }
}
